export const hasMapCoordinates = (item = {}) => (
  Number.isFinite(item.latitude) && Math.abs(item.latitude) <= 90
  && Number.isFinite(item.longitude) && Math.abs(item.longitude) <= 180
);

export const journeyLocationEmbedUrl = (item = {}, fallbackLocation = '') => {
  const query = hasMapCoordinates(item)
    ? `${item.latitude},${item.longitude}`
    : item.mapQuery || [item.title, item.mapLocation || fallbackLocation].filter(Boolean).join(', ');
  return `https://www.google.com/maps?q=${encodeURIComponent(query || fallbackLocation)}&output=embed`;
};
